import { render, staticRenderFns } from "./YearCalendarItemTest.vue?vue&type=template&id=0c9bd216&scoped=true&"
import script from "./YearCalendarItemTest.vue?vue&type=script&lang=js&"
export * from "./YearCalendarItemTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9bd216",
  null
  
)

export default component.exports